"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("curry"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _keys = _interopRequireDefault(require("./keys"));
var _count = _interopRequireDefault(require("./count"));
var reduce = (0, _curry.default)(function (fn, accum, object) {
  if (!object) return accum;
  if ((0, _isArray.default)(object)) return object.reduce(fn, accum);
  if ((0, _isString.default)(object)) return object.split('').reduce(fn, accum);
  var result, i;
  var allKeys = (0, _keys.default)(object);
  var keysLength = (0, _count.default)(allKeys);
  if (keysLength <= 0) return accum;
  if (accum === undefined || accum === null) {
    result = object[allKeys[0]];
    i = 1;
  } else {
    result = accum;
    i = 0;
  }
  for (; i < keysLength; i++) {
    var key = allKeys[i];
    result = fn(result, object[key], key, object);
  }
  return result;
});
var _default = reduce;
exports.default = _default;